// Copyright (c) 2017 Deere & Company

import TcsmApproveDenyModal from '../../wip/state/tcsm-approve-deny-modal';
import actions from '../../actions-list';
import {getDefaultState as getSpaDetailsDefaultState} from '../state';

const closeModal = state =>
    TcsmApproveDenyModal.update(state, {
        isVisible: {
            $set: false
        }
    });

const openModal = (state, action) =>
    TcsmApproveDenyModal.update(state, {
        $merge: {
            actionToTake: action.data,
            isVisible: true
        }
    });

export default (state = getSpaDetailsDefaultState().modal, action) => {

    const actionTypes = {
        [actions.CLOSE_TCSM_SPA_CLAIM_MODAL]: closeModal,
        [actions.OPEN_TCSM_SPA_CLAIM_MODAL]: openModal
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/spa-details/reducers/modal.js